export const initialStateProfile = {
  imgUrl: '',
  firstName: '',
  lastName: '',
  email: '',
  isEnable2FA: false,
  twoFAType: '',
  recoveryEmail: '',
  description: '',
  isVerifiedAuthor: false,
  isFoundingCreator: false,
  username: '',
  id: null
};

export interface ArticleDetails {
  id: string;
  title: string;
  subTitle: string;
  status: 'publish' | 'draft';
  description: string;
  content: {
    editorState: EditorState;
  };
  contentLength: number;
  organization: string;
  creatorId: string;
  createdAt: string;
  updatedAt: string;
  isPublished: boolean;
  publishedAt: string;
  reactionNumber: number;
  viewNumber: number;
  shareNumber: number;
  commentNumber: number;
  isEnableAISummaries: boolean;
  updateNumber: number;
  writingTypeId: number;
  aiSummary: string[];
  sentiment: string | null;
  politicalBias: string | null;
  contentQualityScore: string;
  clickbaitScore: string;
  expertiseScore: string;
  contentTrustworthiness: string;
  balanceScore: string;
  civilityScore: string;
  writingType: WritingType;
  creator: Creator;
  cover: string;
  topics: Topic[];
  hashtags: string[];
  contributors: Contributor[];
  readLength: string;
  isSaved: boolean;
  isIgnored: boolean;
}

interface WritingType {
  id: number;
  name: string;
  description: string;
}

interface Creator {
  id: string;
  firstName: string;
  lastName: string;
  country: string | null;
  username: string;
  email: string;
  imgUrl: string;
  isVerifiedAuthor: boolean;
  isFoundingCreator: boolean;
  description: string | null;
  isFollowing: boolean;
}

interface Topic {
  id: number;
  name: string;
  importance: number;
}

interface Contributor extends Omit<Creator, 'isFollowing'> {
  role: string;
}

interface EditorState {
  root: {
    type: string;
    format: string;
    indent: number;
    version: number;
    children: Array<EditorNode>;
    direction: string | null;
  };
}

interface EditorNode {
  type: string;
  format: string;
  indent: number;
  version: number;
  children: Array<TextNode | ImageNode | ExcalidrawNode | EditorNode>;
  direction?: string | null;
  tag?: string;
  textFormat?: number;
  paragraphId?: string;
  commentCount?: number;
}

interface TextNode {
  mode: string;
  text: string;
  type: 'text';
  style: string;
  detail: number;
  format: number;
  version: number;
}

interface ImageNode {
  src: string;
  type: 'image';
  width: number;
  height: number;
  altText: string;
  caption: {
    editorState: EditorState;
  };
  version: number;
  imageType: string;
  showCaption: boolean;
}

interface ExcalidrawNode {
  data: string;
  type: 'excalidraw';
  width: string;
  height: string;
  version: number;
}
